/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup } from '@elastic/eui'

import type { AnyCluster } from '@modules/ccm-lib/types'
import { isCCMService } from '@modules/ccm-lib/util'

import ServiceItemSelector from '../service-item'

import type { FC } from 'react'

type Props = {
  ccmCluster: AnyCluster
}

const ServiceList: FC<Props> = ({ ccmCluster }) => (
  <EuiFlexGroup direction='column' gutterSize='l'>
    {Object.entries(ccmCluster.services)
      .toSorted(ccmServiceSort)
      .map(([serviceId]) => {
        if (!isCCMService(serviceId)) {
          // should never happen, but Object.entries keys are not typed
          return null
        }

        return <ServiceItemSelector key={serviceId} service={serviceId} cluster={ccmCluster} />
      })}
  </EuiFlexGroup>
)

type AnyService = AnyCluster['services'][keyof AnyCluster['services']]

const ccmServiceSort = (a: [string, AnyService], b: [string, AnyService]) => {
  const [serviceIdA, serviceA] = a
  const [serviceIdB, serviceB] = b

  if (serviceA.enabled && !serviceB.enabled) {
    return -1
  }

  if (!serviceA.enabled && serviceB.enabled) {
    return 1
  }

  return serviceIdA.localeCompare(serviceIdB)
}

export default ServiceList
